var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.organisation)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.organisation.name)+" Dash")]),_c('h1',[_vm._v("Welcome "+_vm._s(_vm.user.displayName))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }